import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
export function HeroSection() {
  const [videoError, setVideoError] = useState(false);
  return <section className="relative h-[500px] md:h-[600px] overflow-hidden" data-id="element-198">
      {/* Video Background */}
      <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-transparent z-10" data-id="element-199" />

      {!videoError ? <video autoPlay loop muted playsInline className="absolute inset-0 w-full h-full object-cover" onError={() => setVideoError(true)} data-id="element-200">
          <source src="https://assets.mixkit.co/videos/preview/mixkit-fresh-vegetables-in-a-supermarket-4278-large.mp4" type="video/mp4" data-id="element-201" />
        </video> : <div className="absolute inset-0 w-full h-full bg-cover bg-center" style={{
      backgroundImage: 'url(https://images.unsplash.com/photo-1542838132-92c53300491e?auto=format&fit=crop&q=80&w=2000)'
    }} data-id="element-202" />}

      {/* Content */}
      <div className="relative z-20 h-full max-w-7xl mx-auto px-4 md:px-6 flex items-center" data-id="element-203">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="max-w-2xl mt-8 md:mt-0" data-id="element-204">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.2,
          duration: 0.6
        }} className="inline-flex items-center gap-2 bg-[#F4A261]/90 backdrop-blur-sm text-white px-3 md:px-4 py-1.5 md:py-2 rounded-full mb-4 md:mb-6" data-id="element-205">
            <span className="w-2 h-2 bg-white rounded-full animate-pulse" data-id="element-206" />
            <span className="text-xs md:text-sm font-semibold" data-id="element-207">
              Now Accepting WIC & EBT
            </span>
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.3,
          duration: 0.6
        }} className="text-3xl md:text-6xl font-bold text-white mb-4 md:mb-6 leading-tight" data-id="element-208">
            Authentic African & Caribbean Groceries
            <span className="block text-[#F4A261] mt-1 md:mt-2" data-id="element-209">
              Delivered Fresh
            </span>
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.4,
          duration: 0.6
        }} className="text-base md:text-xl text-gray-100 mb-6 md:mb-8 leading-relaxed" data-id="element-210">
            From fufu flour to fresh plantains, find everything you need for
            your traditional recipes. Proudly serving the Cheverly community.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.5,
          duration: 0.6
        }} className="flex flex-col md:flex-row items-stretch md:items-center gap-3 md:gap-4 mb-6 md:mb-0" data-id="element-211">
            <Link to="/search" className="group bg-[#D97757] hover:bg-[#c66545] text-white px-6 md:px-8 py-3.5 md:py-4 rounded-xl font-bold text-base md:text-lg shadow-xl transition-all hover:shadow-2xl hover:scale-105 flex items-center justify-center gap-2" data-id="element-212">
              Shop Now
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-213" />
            </Link>

            <Link to="/wic-ebt-guide" className="group bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white px-6 md:px-8 py-3.5 md:py-4 rounded-xl font-bold text-base md:text-lg border-2 border-white/30 transition-all flex items-center justify-center gap-2" data-id="element-214">
              Learn About WIC/EBT
            </Link>
          </motion.div>

          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.7,
          duration: 0.6
        }} className="hidden md:flex mt-8 items-center gap-6 text-white/90" data-id="element-215">
            <div className="flex items-center gap-2" data-id="element-216">
              <div className="w-10 h-10 bg-white/10 backdrop-blur-sm rounded-full flex items-center justify-center" data-id="element-217">
                <span className="text-2xl" data-id="element-218">🚚</span>
              </div>
              <div className="text-sm" data-id="element-219">
                <div className="font-semibold" data-id="element-220">Free Delivery</div>
                <div className="text-white/70" data-id="element-221">Orders over $35</div>
              </div>
            </div>

            <div className="flex items-center gap-2" data-id="element-222">
              <div className="w-10 h-10 bg-white/10 backdrop-blur-sm rounded-full flex items-center justify-center" data-id="element-223">
                <span className="text-2xl" data-id="element-224">✓</span>
              </div>
              <div className="text-sm" data-id="element-225">
                <div className="font-semibold" data-id="element-226">Same-Day Delivery</div>
                <div className="text-white/70" data-id="element-227">Order by 2 PM</div>
              </div>
            </div>
          </motion.div>
        </motion.div>
      </div>

      {/* Scroll Indicator - Hidden on mobile */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1,
      duration: 0.6
    }} className="hidden md:block absolute bottom-8 left-1/2 -translate-x-1/2 z-20" data-id="element-228">
        <motion.div animate={{
        y: [0, 10, 0]
      }} transition={{
        repeat: Infinity,
        duration: 1.5,
        ease: 'easeInOut'
      }} className="w-6 h-10 border-2 border-white/50 rounded-full flex items-start justify-center p-2" data-id="element-229">
          <div className="w-1 h-2 bg-white/70 rounded-full" data-id="element-230" />
        </motion.div>
      </motion.div>
    </section>;
}